const styles = (theme) => ({
  paperContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: "20px",
    borderRadius: "16px",
    width: "100%",
  },
  paperSupContainer: {
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  paperDatagrid: {
    width: "100%",

    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "500px",
    p: 2,
  },
  boxActions: { display: "flex", justifyContent: "space-between" },
  title: { fontWeight: "bold", fontSize: "20px", mb: 2 },
  containerDatagridGrupos: {
    display: "flex",
    justifyItems: "start",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "230px",
    alignItems: "center",
    gap: 0.5,
    overflow: "hidden",
    minWidth: 0,
  },
  containerAcoes: {
    display: "flex",
    gap: 1,
  },

  containerAcoesButton: {
    display: "flex",
    gap: 1,
  },
  buttonGrupo: {
    width: "100%",
    display: "flex",
    justifyContent: "start",
    maxWidth: "160px",
    minHeight: "100%",
    p: "1px 4px",
  },
  chipGrupo: {
    margin: "3px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
    color: theme.palette.white.main,
    fontSize: "0.7rem",

    minWidth: 0,
  },
  containerGrupo: {
    maxHeight: "200px",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  boxInfo: {
    display: "flex",
    flexDirection: "column",
    p: 1,
    alignItems: "center",
  },
  textInfo: { fontWeight: "bold", opacity: 0.5, fontSize: "0.8rem" },
  chipCount: {
    height: 18,
    fontSize: "0.65rem",
    color: theme.palette.white.main,
    fontWeight: "bold",
    backgroundColor: "chip.main.arquive",
  },
  textNoGrupo: {
    fontSize: "0.875rem",

    fontWeight: 500,
    fontWeight: "bold",
  },
  containerHandleButtons: {
    margin: "10px",
    display: "flex",
    justifyContent: "end",
    gap: 1,
  },
  colorSelectChip: {
    height: "15px",
    width: "15px",
    margin: "3px 10px",
  },
  chip: {
    height: "auto",
    "& .MuiChip-label": {
      display: "block",
      whiteSpace: "normal",
    },
    color: theme.palette.white.main,
  },
  iconInfoOutlined: { width: "16px", mt: "-1px" },
  boxCreateModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "800px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    minHeight: "500px",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  boxActionsCreateModal: {
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
  },
  buttonAddGrupo: {
    width: "100%",
    justifyContent: "space-between",
    textAlign: "left",
  },

  // ===== Seção "Configurações" (visibilidade de CDNs/tráfego) =====
  sectionTabs: {
    minHeight: "40px",
    mb: 2,
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& .MuiTabs-indicator": {
      height: "3px",
      borderRadius: "3px 3px 0 0",
    },
  },
  sectionTab: {
    minHeight: "40px",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.85rem",
    gap: 0.5,
  },
});
export default styles;
